<template>
  <div class="medical-result">
    <template v-if="results.length > 0">
      <div id="medSearchResultstable" class="table">
        <template v-for="(item, i) in results">
          <div :key="i" class="row" @click="selectDoc(item)">
            <div class="cell">
              <div class="paragraph-xs">
                {{ $t('core_medicalofficesearch_name_title') }}
              </div>
              <div class="title">{{ item.name }} {{ item.surname }}</div>
              <div
                class="receptive-state"
                :class="{ [getStateClass(item.officeState)]: true }"
              >
                <dotcom-icon
                  :name="getStateIcon(item.officeState)"
                  :color="getStateIconColor(item.officeState)"
                  :hover-color="getStateIconColor(item.officeState)"
                  art="light"
                  :class="getStateClass(item.officeState)"
                />
                <div
                  class="state"
                  :class="{ [getStateClass(item.officeState)]: true }"
                >
                  {{ getOfficeState(item.officeState) }}
                </div>
              </div>
            </div>

            <div class="cell">
              <div class="paragraph-xs">
                {{ $t('core_medicalofficesearch_address_title') }}
              </div>
              <div>{{ item.address }}</div>
              {{ item.plz }} {{ item.region }}
            </div>

            <div class="cell">
              <div class="paragraph-xs">
                {{ $t('core_medicalofficesearch_phone_title') }}
              </div>
              {{ item.phone }}
            </div>

            <div class="cell">
              <div class="paragraph-xs">
                {{ $t('core_medicalofficesearch_network_title') }}
              </div>
              <p
                v-for="network in item.networks"
                :key="network"
                class="font-11"
              >
                {{ network }}
              </p>
            </div>

            <div class="cell">
              <div class="paragraph-xs">
                {{ $t('core_medicalofficesearch_product_title') }} *
              </div>
              <p
                v-for="product in joinProductsAndRabat(item.medicalOfficeNets)"
                :key="product"
                class="font-11"
              >
                {{ product }}
              </p>
            </div>
          </div>
        </template>
        <div class="paragraph-s">
          * {{ $t('core_medicalofficesearch_asterisk_title') }}
        </div>
      </div>
    </template>
    <template v-else-if="searchExecuted && !results.length">
      <alert-message
        :text="$t('core_medicalofficesearch_noresults_title')"
        warning
      />
    </template>
  </div>
</template>

<script>
import { useI36n } from '@jota-one/i36n/src/index.vue2'

import AlertMessage from './AlertMessage'

export default {
  name: 'SanitasMedicalOfficeResults',
  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    AlertMessage,
  },
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    searchExecuted: Boolean,
  },

  setup() {
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },

  methods: {
    selectDoc(item) {
      console.log(item)
    },
    getStateIconColor(state) {
      switch (this.getStateClass(state)) {
        case 'is-true':
          return '--c-primary-color-2'
        case 'is-false':
          return '--c-secondary-color-1'
        case 'is-according-family':
          return '--c-secondary-color-3'
        default:
          return '--c-secondary-neutral-2'
      }
    },
    getStateIcon(state) {
      const iconMap = {
        ACCEPTS_CHILDREN: 'face-smile',
        ACCEPTS_NOBODY: 'ban',
        ACCEPTS_FAMILYMEMBERS: 'family',
        SPECIALIST_NOT_ELIGIBLE: 'circle-exclamation',
        ACCORDING_FAMILY_DOCTOR: 'circle-exclamation',
        STATUS_UNKNOWN: 'circle-question',
      }

      return iconMap[state] ? iconMap[state] : 'circle-check'
    },
    getStateClass(state) {
      const classMap = {
        ACCEPTS_NOBODY: 'is-false',
        ACCEPTS_ALL: 'is-true',
        ACCORDING_FAMILY_DOCTOR: 'is-according-family',
      }

      return classMap[state] ? classMap[state] : 'is-custom'
    },
    getOfficeState(state) {
      switch (state) {
        case 'ACCEPTS_ALL':
          return this.$t('core_medicalofficesearch_accepts_all_title')

        case 'ACCORDING_FAMILY_DOCTOR':
          return this.$t(
            'core_medicalofficesearch_according_family_doctor_title',
          )

        case 'ACCEPTS_NOBODY':
          return this.$t('core_medicalofficesearch_accepts_nobody_title')

        case 'ACCEPTS_CHILDREN':
          return this.$t('core_medicalofficesearch_accepts_children_title')

        case 'ACCEPTS_FAMILYMEMBERS':
          return this.$t('core_medicalofficesearch_accepts_familymembers_title')

        case 'SPECIALIST_NOT_ELIGIBLE':
          return this.$t('core_medicalofficesearch_accepts_not_eligible_title')

        case 'STATUS_UNKNOWN':
        /* falls through */
        default:
          return this.$t('core_medicalofficesearch_accepts_unknown_title')
      }
    },
    joinProductsAndRabat(data) {
      return data.map(val => {
        if (val.avmDefinition === 'CAREMED') {
          return (
            this.$t('core_medicalofficesearch_product_CAREMED_title') +
            this.$t('core_medicalofficesearch_discountTextCaremed')
          )
        } else if (val.avmDefinition === 'NETMED') {
          if (val.discountGroup === '1') {
            return (
              this.$t('core_medicalofficesearch_product_NETMED_title') +
              this.$t('core_medicalofficesearch_discountTextNetmed1')
            )
          } else if (val.discountGroup === '2') {
            return (
              this.$t('core_medicalofficesearch_product_NETMED_title') +
              this.$t('core_medicalofficesearch_discountTextNetmed2')
            )
          } else if (val.discountGroup === '3') {
            return (
              this.$t('core_medicalofficesearch_product_NETMED_title') +
              this.$t('core_medicalofficesearch_discountTextNetmed3')
            )
          }
        } else if (val.avmDefinition === 'MEDBASE') {
          return (
            this.$t('core_medicalofficesearch_product_MEDBASE_title') +
            this.$t('core_medicalofficesearch_discountTextMedbase')
          )
        }
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.medical-result {
  .table {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    border-top: 1px dashed var(--c-secondary-neutral-3);

    .row {
      display: flex;
      flex-wrap: wrap;
      margin: 10px 0;

      border: 1px solid var(--c-secondary-neutral-3);
      border-radius: 6px;
      padding: 10px;

      transition: 0.45s;

      &:hover {
        box-shadow: 0 4px 8px 0 rgba(18, 37, 31, 0.35);
      }

      .cell {
        display: block;
        width: 100%;
        margin: 5px 0;
        box-sizing: border-box;

        font-weight: 400;
        font-style: normal;
        font-size: 13px;
        line-height: 1.35;
        color: var(--c-primary-neutral-1);

        .title {
          font-weight: 700;
          font-style: normal;
          font-size: 15px;
          line-height: 1.25;
          letter-spacing: 0;
          color: var(--c-primary-neutral-1);
          padding-bottom: 5px;
        }

        .receptive-state {
          font-weight: 400;
          font-style: normal;
          font-size: 13px;
          line-height: 1.35;
          color: var(--c-primary-neutral-1);
          display: flex;

          .dotcom-icon {
            margin-right: 5px;
            font-size: 18px;
          }

          .state {
            width: calc(100% - 18px);

            &.is-true {
              color: var(--c-primary-color-2);
            }

            &.is-false {
              color: var(--c-secondary-color-1);
            }

            &.is-according-family {
              color: var(--c-secondary-color-3);
            }

            &.is-custom {
              color: var(--c-secondary-neutral-2);
            }
          }
        }

        &:first-child {
          padding-bottom: 10px;
          border-bottom: 1px dashed var(--c-secondary-neutral-3);
        }

        &:nth-child(5) {
          display: inline-block;
          width: 100%;
        }
      }
    }
  }

  .paragraph-xs {
    font-weight: 400;
    font-style: normal;
    font-size: 11px;
    line-height: 1;
    color: var(--c-primary-neutral-1);
    padding: 10px 0;
  }

  .paragraph-s {
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    line-height: 1.35;
    color: var(--c-primary-neutral-1);
  }

  .font-11 {
    font-size: 11px;
  }

  @media (max-width: 1023px) and (--md) {
    .table {
      .row {
        .cell {
          &:nth-child(5) {
            border-right: none;
          }
        }
      }
    }
  }

  @media (--md) {
    .table {
      .row {
        .cell {
          flex: 1;
          padding-left: 10px;
          padding-right: 10px;
          border-right: 1px dashed var(--c-secondary-neutral-3);

          &:first-child {
            border-bottom: none;
          }

          &:first-child,
          &:nth-child(2) {
            flex: 2;
          }

          &:last-child {
            border-left: none;
            border-right: none;
            flex: 2;
          }
        }
      }
    }
  }
}
</style>
